import React, { Component } from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

import PageWrapper from './ui/PageWrapper';

const Wrapper = styled.div`
  display: grid;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  @media only screen and (min-width: 900px) {
    grid-template-columns: 1fr 300px;
  }
  @media only screen and (min-width: 480px){
    padding: 0 50px;
    > div {
      padding-right: 40px;
    }
  }
  .links {
    color: #adadad;
    > a {
      text-decoration: none;
      &:hover {
        color: #fa0068;
        padding-bottom: 2px;
        border-bottom: 1px solid #fa0068;
      }
    }
    > .mobile {
      @media only screen and (min-width: 633px){
        display: none;
      }
    }
  }
`;

const H2 = styled.h2`
  color: white;
  font-family: Capricorn, sans-serif;
  font-size: 34px;
  font-weight: normal;
  letter-spacing: 0.06em;
`;

class About extends Component {
  render() {
    return (
      <PageWrapper>
        <Wrapper>
          <div>
            <H2>
            About
            </H2>
            My work harnesses basic shapes from the digital world, reifying them in physical reality to expand the liminal space between. Through a wide range of techniques ranging from custom software crafted for each piece to careful composition and contemporary CNC fabrication methods, my process itself continuously evolves in order to realize complex and graceful forms in our tangible reality. I am fascinated by the transitionary state humanity has found itself in, where the boundaries of digital and physical, virtual and real, having only just been established, are almost immediately washing away. My work lives on this tenuous divide, confusing the notion of a render and a photo, handmade and computer-fabricated.
          </div>
          <div>
            <H2>
            Info
            </H2>
            Nicole Aptekar lives and works in
            <br></br>
            Brooklyn, NY
            <p>nicole@nicoleaptekar.com</p>
            <p className="links">
              <a href="https://instagram.com/nicole.aptekar">Instagram</a>
            </p>
            <p className="links">
              <NavLink to="/exhibitions" className="mobile">Exhibition List</NavLink>
            </p>
          </div>
        </Wrapper>
      </PageWrapper>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js